import { createContext } from 'react';

const state = {
  sb: null,
  currentUser: null,
};

const ConnectContext = createContext(state);

export default ConnectContext;
